import React, { useEffect, useState } from "react";
import classes from "./Layout.module.css";
import Toolbar from "../Navigation/Toolbar/Toolbar";
import SideDrawer from "../Navigation/SideDrawer/SideDrawer";
import { withRouter } from "react-router-dom";
import { withAuthentication } from "../../hoc/withAuthentication";
import { getActiveShop } from "@/constants/utility";
import { doInterval } from "@/utility/helpers";
import AdminCode from "../Employee/AdminCode";
import Timezone from "../Settings/Sections/Timezone";
import ProtectWithEmployeeCode from "../Employee/ProtectWithEmployeeCode";
import StorageUtils from "@/utility/StorageUtils";
import SessionUtils from "@/utility/SessionUtils";
import Confirmation from "@/custom_components/Confirmation";
import useFetch from "@/hoc/useFetch";

const Layout = ({ children, user, httpClient, history }) => {
  const { data: merchantInfo = {}, status } = useFetch({
    url: `/integration/${user.selectedShop}?service=payrix`,
  });

  const padding = classes.Padding;

  const sideCollapsed = user.sidebar && user.sidebar.isCollapsed;
  const selectedShop = getActiveShop(user);
  const [confirm, setconfirm] = useState(false);
  const [timeout, settimeout] = useState();
  const [employee, setEmployee] = useState(() => SessionUtils.getItem("rs_employee") || null);

  useEffect(() => {
    if (!StorageUtils.getToken()) {
      window.location.href = "/logout";
    }
  }, []);

  useEffect(() => {
    if (status == "complete") {
      if (merchantInfo?.active) {
        user.setTerminalActive(merchantInfo?.active);
      } else {
        user.setTerminalActive(false);
      }
    }
  }, [status]);

  const updateShop = async () => {
    let shop = await httpClient.get(`/repairshop/stores/${user.selectedShop}`);
    user.updateShop(shop);
  };

  useEffect(() => {
    getShopBusinessDetails();
    updateShop();
    getCurrentlyLoggedInUser();
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  const getCurrentlyLoggedInUser = () => {
    doInterval((interval) => {
      const hasExcludePolling = document.querySelector(".exclude-polling");
      if (hasExcludePolling) {
        return;
      }

      httpClient
        .get(`/account/me`)
        .then((data) => {
          const { token, stores, storesData, adminstores, ...rest } = data;
          settimeout(interval);
          const shop = getActiveShop({
            selectedShop: user.selectedShop,
            storesData,
          });
          settimeout(interval);
          user.updateShop(shop);
          user.updateUser(rest);
        })
        .catch((error) => {
          if (error?.response?.status == 401) {
            window.location.href = "/logout";
          }
        });
    }, 60 * 1000);
  };

  const getShopBusinessDetails = () => {
    httpClient
      .get(`/repairshop/businessDetails/${user.selectedShop}`)
      .then((data) => {
        user.updateShop(data);
      })
      .catch((error) => {
        if (error?.response?.status == 401) {
          clearTimeout(timeout);
          window.location.href = "/logout";
        }
      });
  };

  const isAccountant = /accountant/i.test(user.type);
  const hideSideDrawer = /(free)/gi.test((selectedShop || {}).plan) || isAccountant || user?.fromLogin;
  const hideNav = hideSideDrawer;
  const classNames = [classes.Content, padding, !!sideCollapsed ? "sideActive" : ""].join(" ");
  useEffect(() => {
    if (hideSideDrawer) {
      history.push("/multi-manager");
    }
  }, []);
  useEffect(() => {
    if (user?.isRetail) {
      document.documentElement.classList.add("retail");
    }
    // Apply class to <html> for :root variables
  }, [selectedShop]);
  const Managerbar = () => {
    return (
      <header className="uk-flex uk-flex-between uk-flex-middle uk-clearfix uk-card-header uk-text-center uk-background-danger tm-text-white uk-width-1-1 uk-margin-bottom">
        <div className="uk-text-left">
          <div className="uk-flex uk-flex-between uk-flex-middle"></div>
        </div>
        <div className="uk-text-center">
          <img
            style={{ width: "300px", height: "40px" }}
            src={`/icons/header/logo-${user.isRetail ? "retail" : "repair"}.svg`}
          />
        </div>
        <div className="uk-text-right">
          <div className="uk-flex uk-flex-between uk-flex-middle">
            <div className="pointer">
              <a onClick={() => setconfirm(true)}>
                <img className="uk-svg" src="/icons/header/logout.svg" />
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  };
  return /true/i.test(selectedShop?.isSuspended) || !condition(user) ? null : (
    <ProtectWithEmployeeCode
      employeeType="employee"
      showOnRender={!user?.fromLogin}
      onUpdate={setEmployee}
      user={employee}
    >
      {(props) => (
        <React.Fragment>
          <div className="uk-position-relative" style={{ minHeight: "100vh", backgroundColor: "var(--bg-primary)" }}>
            <React.Fragment>
              <div
                style={{
                  position: "fixed",
                  top: "0",
                  width: "100vw",
                  zIndex: 2,
                }}
              >
                {hideNav ? Managerbar() : <Toolbar employee={employee} />}
              </div>

              {!hideSideDrawer && <SideDrawer merchantInfo={merchantInfo} employee={employee} />}
            </React.Fragment>

            <section style={{ marginTop: "50px" }} className="uk-container-expand " uk-height-viewport="expand: true">
              <main id="layout" className={hideNav ? padding : classNames}>
                {children}
              </main>
            </section>
            {/* <div
            style={{ padding: "2px" }}
            uk-scroll=""
            className={`
                     uk-background-danger uk-position-fixed
                     uk-border-pill uk-light
                     uk-flex uk-flex-middle
                     uk-box-shadow-small
                     uk-position-bottom-right
                     uk-position-small
                   `}
          >
            <a href="#" className="" uk-totop=""></a>
          </div> */}
            <AdminCode />
            {confirm && (
              <Confirmation
                message={"Are you sure you would like to logout?"}
                proceedLabel={"Logout"}
                onCancel={() => setconfirm(false)}
                onProceed={() => {
                  history.push("/logout");
                }}
              />
            )}
            {!selectedShop?.timezone && !/free/i.test(selectedShop?.plan) ? <Timezone /> : null}
          </div>
        </React.Fragment>
      )}
    </ProtectWithEmployeeCode>
  );
};

const condition = (authUser) => {
  return authUser.selectedShop && authUser.email;
};

export default withAuthentication(withRouter(Layout));

// ;
